import { request } from './api.js';

// #46: Projektstruktur (Teilprojekte/Streams). Projekt-gescoped, unter /catalog gemountet.
export interface StructureNode {
  node_id: string;
  kind: 'teilprojekt' | 'stream';
  name: string;
  parent_node_id: string | null;
  // #112: An einem Teilprojekt die Zahl der Prozesse, an einem Stream die der Ketten — der
  // Server liefert je Knotenart die passende Zahl unter `process_count`. `e2e_count` steht
  // zusaetzlich bereit, damit die Beschriftung die richtige Sache benennen kann.
  process_count: number;
  e2e_count: number;
}

export interface NodeDependents {
  roles: number;
  processes: number;
  signoffs: number;
  children: number;
  // #112: Ketten am Stream. Ohne dieses Feld haette der Loeschdialog die Ketten verschwiegen —
  // der Riegel greift serverseitig, aber der Nutzer haette nicht erfahren, WAS ihn aufhaelt.
  // Optional gelesen, damit eine aeltere Antwort ohne das Feld weiterhin verarbeitet wird.
  e2e_processes?: number;
}

const base = (p: string) => `/v1/projects/${p}/catalog`;

export const structureApi = {
  list: (p: string) => request<StructureNode[]>(`${base(p)}/structure-nodes`),
  create: (p: string, body: { kind: 'teilprojekt' | 'stream'; name: string }) =>
    request<StructureNode>(`${base(p)}/structure-nodes`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  rename: (p: string, id: string, name: string) =>
    request<StructureNode>(`${base(p)}/structure-nodes/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ name }),
    }),
  remove: (p: string, id: string) =>
    request<void>(`${base(p)}/structure-nodes/${id}`, { method: 'DELETE' }),
};

// Der 409-Body des Lösch-Endpunkts (node_has_dependents) steckt als Text in ApiError.message.
// Diese Hilfe liest die Abhängigkeits-Zahlen heraus, damit das Panel sie benennen kann.
export function parseNodeDependents(message: string): NodeDependents | null {
  try {
    const body = JSON.parse(message) as { error?: string; dependents?: NodeDependents };
    if (body.error === 'node_has_dependents' && body.dependents) return body.dependents;
  } catch {
    // kein JSON-Body → kein struktureller Abhängigkeits-Fehler
  }
  return null;
}
